import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { zipCodeValidator } from 'src/app/directives/zip-code/zip-code.directive';
import { BranchService } from 'src/app/services/branch/branch.service';
import {
  Dropdown,
  DropdownMenus,
} from 'src/app/services/dropdowns/dropdowns.model';
import { DropdownsService } from 'src/app/services/dropdowns/dropdowns.service';
import { FinalLoanApplication } from 'src/app/services/loan/loan.model';
import { LoanService } from 'src/app/services/loan/loan.service';
import { RouteName } from '../loan-routing.module';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['./area.component.scss'],
})
export class AreaComponent implements OnInit, OnDestroy {
  serviceAreaFormGroup: FormGroup;
  loanApplication: FinalLoanApplication | null = null;
  loading = false;
  dropdownMenus: DropdownMenus | null = null;
  referralTypes: Array<Dropdown> = [];
  isDirtyAndMissingRequiredFields = false;

  private subscriptions: Array<Subscription> = [];

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private loanService: LoanService,
    private dropdownsService: DropdownsService,
    private branchService: BranchService,
    private titleService: Title
  ) {
    this.titleService.setTitle('Eagle Loan | Get Started');

    this.serviceAreaFormGroup = this.formBuilder.group({
      RequestZip: ['', [Validators.required, zipCodeValidator]],
      RequestAmount: [
        '',
        [Validators.required, Validators.max(10000), Validators.min(1000)],
      ],
      RequestPurpose: ['', Validators.required],
      RequestCreditTypeCD: ['', Validators.required],
      RequestReferCD: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.dropdownsService.dropdownMenus.subscribe(
        (data: DropdownMenus | null) => {
          if (data) {
            this.dropdownMenus = { ...data };
            this.referralTypes = [...this.dropdownMenus.requestReferalTypes];
          }
        }
      )
    );

    this.subscriptions.push(
      this.dropdownsService.loading.subscribe((isLoading: boolean) => {
        this.loading = isLoading;
      })
    );

    this.subscriptions.push(
      this.loanService.finalLoanApplication.subscribe(
        (data: FinalLoanApplication | null) => {
          if (data) {
            this.loanApplication = { ...data };

            if (data.LoanApplication) {
              this.setFormValues(data.LoanApplication);
            }
          }
        }
      )
    );

    this.subscriptions.push(
      this.serviceAreaFormGroup.statusChanges.subscribe((status: string) => {
        if (status && status === 'VALID') {
          this.isDirtyAndMissingRequiredFields = false;
        }
      })
    );

    if (!this.dropdownMenus) {
      this.dropdownsService.getDropdowns();
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length > 0) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
  }

  setFormValues(data: any) {
    // Set form values
    Object.keys(data).forEach((key) => {
      // Check if key exists on current form.
      if (this.serviceAreaFormGroup.controls[key]) {
        this.serviceAreaFormGroup.controls[key].setValue(data?.[key]);
      }
    });
  }

  onApplyNow() {
    this.isDirtyAndMissingRequiredFields = false;

    if (this.serviceAreaFormGroup.invalid) {
      this.serviceAreaFormGroup.markAllAsTouched();
      this.isDirtyAndMissingRequiredFields = true;
      return;
    }

    this.loanService.setGetStarted({ ...this.serviceAreaFormGroup.value });

    this.branchService.clearBranchesOnSearch();

    this.router.navigateByUrl(RouteName.branch);
  }

  controlIsRequired(key: string): boolean {
    if (
      this.serviceAreaFormGroup.controls[key].hasValidator(Validators.required)
    ) {
      return true;
    }

    return false;
  }

  onChangeEvent(event: string) {
    if (this.loanApplication) {
      this.loanService.clearCoApplicantOnApplicationTypeChange(event);
    }
  }
}
